import React, { useState, useEffect } from 'react';
import { getVisitors, clearVisitors, formatDateTime, parseUserAgent } from '../services/visitorTrackingService';
import './VisitorsScreen.css';

const VisitorsScreen = ({ onClose }) => {
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadVisitors();
  }, []);

  const loadVisitors = async () => {
    setLoading(true);
    try {
      const data = await getVisitors();
      setVisitors(data);
    } catch (error) {
      console.error('خطأ في تحميل الزوار:', error);
      setVisitors([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClear = async () => {
    if (window.confirm('هل أنت متأكد من حذف جميع سجلات الزوار؟')) {
      try {
        await clearVisitors();
        await loadVisitors();
      } catch (error) {
        console.error('خطأ في حذف الزوار:', error);
      }
    }
  };

  return (
    <div className="visitors-screen-overlay" onClick={onClose}>
      <div className="visitors-screen" onClick={(e) => e.stopPropagation()}>
        <div className="visitors-header">
          <h1 className="visitors-title">سجل الزوار</h1>
          <button className="visitors-close-button" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="visitors-actions">
          <button className="visitors-refresh-button" onClick={loadVisitors}>
            🔄 تحديث
          </button>
          <button className="visitors-clear-button" onClick={handleClear}>
            🗑️ حذف الكل
          </button>
        </div>

        <div className="visitors-content">
          {loading ? (
            <div className="visitors-loading">جاري التحميل...</div>
          ) : visitors.length === 0 ? (
            <div className="visitors-empty">
              <div className="visitors-empty-icon">📭</div>
              <p>لا توجد سجلات زوار</p>
            </div>
          ) : (
            <div className="visitors-list">
              <div className="visitors-stats">
                <span className="visitors-count">إجمالي الزوار: {visitors.length}</span>
              </div>
              <div className="visitors-table-container">
                <table className="visitors-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>التاريخ والوقت</th>
                      <th>المتصفح</th>
                      <th>الجهاز</th>
                      <th>الدقة</th>
                      <th>المصدر</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visitors.map((visitor, index) => {
                      const { browser, device } = parseUserAgent(visitor.userAgent || '');
                      return (
                        <tr key={visitor.id || `visitor_${index}`}>
                          <td>{index + 1}</td>
                          <td>{formatDateTime(visitor.timestamp)}</td>
                          <td>{browser}</td>
                          <td>{device}</td>
                          <td>{visitor.screenWidth} × {visitor.screenHeight}</td>
                          <td className="visitors-referrer">
                            {visitor.referrer === 'direct' ? 'مباشر' : 
                             visitor.referrer.length > 30 ? 
                             visitor.referrer.substring(0, 30) + '...' : 
                             visitor.referrer}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default VisitorsScreen;

